'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MESSAGE_WIDTH = 280;
const MESSAGE_HEIGHT = 20;
const GlobalContentNoAccessLabel = ({
  width,
  height
}) => {
  if (width > MESSAGE_WIDTH && height > MESSAGE_HEIGHT) {
    return /*#__PURE__*/_jsx("div", {
      style: {
        alignItems: 'center',
        display: 'flex',
        height,
        justifyContent: 'center',
        position: 'absolute',
        width,
        zIndex: 5
      },
      children: /*#__PURE__*/_jsxs(Tag, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "inpage.overlays.globalNoAccessMessage"
        }), /*#__PURE__*/_jsx(HelpIcon, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "inpage.actionToolbar.module.cantEditGlobal"
          }),
          marginInlineStart: "200"
        })]
      })
    });
  }
  return null;
};
GlobalContentNoAccessLabel.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired
};
export default GlobalContentNoAccessLabel;